import * as Types from '../actions/types';

export default function (state={},action){
    switch(action.type){
        case Types.LOOKING_UP_AUTH_APP:
            return {loaded:false};
        case Types.AUTH_APP_EXISTS:
            return {authApp:action.payload,loaded:true};
        case Types.AUTH_APP_ERROR:
            return {loaded:true,error:action.payload};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/authorise.js